<template>
  <b-alert show :variant="variant" class="certificate-import-failure" role="alert">
    <span class="certificate-import-failure-text">{{ text }}</span>
    <b-button v-if="command" size="sm" variant="primary" class="ml-3" @click="$emit(command.event)">{{
      command.label
    }}</b-button>
  </b-alert>
</template>

<script>
// How a certificate import ended when it failed: the words and the one command the failure goes with, both
// from failurePresentation. No reference for the support is shown. Where it sits is up to the page.
import { failurePresentation, IMPORT_ACTIONS, FAILURE_TYPES } from '../../utils/failurePresentation'

const COMMANDS = {
  [IMPORT_ACTIONS.RETRY]: { event: 'retry', key: 'retry' },
  [IMPORT_ACTIONS.UPLOAD_ANOTHER]: { event: 'upload-another', key: 'uploadAnother' },
  [IMPORT_ACTIONS.USE_MARKET_PRODUCT]: { event: 'use-market-product', key: 'useMarketProduct' },
}

export default {
  props: {
    // The failed operation: { kind, errorCode, errorAction, step }.
    failure: {
      type: Object,
      required: true,
    },
    // Whether the same file can be sent again ("Try again" needs it).
    canRetry: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    presentation() {
      return failurePresentation(this.failure)
    },

    text() {
      return this.$t(this.presentation.textKey, this.presentation.textParams)
    },

    variant() {
      return this.presentation.type === FAILURE_TYPES.BLOCKING ? 'danger' : 'warning'
    },

    command() {
      const command = COMMANDS[this.presentation.command]
      if (!command || (command.event === 'retry' && !this.canRetry)) {
        return null
      }
      return { event: command.event, label: this.$t('pit.certificate.actions.' + command.key) }
    },
  },
}
</script>
